// this is an autogenerated file from DesignSystem/DataVaxiomSysOrganizationsParentCompanyLocationSelect/ParentCompany/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_DataVaxiomSysOrganizationsParentCompanyLocationSelect_ParentCompany{
  vaxiom_sys_organizations(
    where: { level: { _eq: "parent" }, deleted: { _eq: false } }
    order_by: { name: asc }
  ) {
    id
    _id
    text: name
  }
}

`